export const RESET = 'EXABORGANIZATIONLEAD_LIST_RESET'
export const SET_ITEMS = 'EXABORGANIZATIONLEAD_LIST_SET_ITEMS'
export const SET_ERROR = 'EXABORGANIZATIONLEAD_LIST_SET_ERROR'
export const SET_VIEW = 'EXABORGANIZATIONLEAD_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXABORGANIZATIONLEAD_LIST_TOGGLE_LOADING'
export const SET_TOTAL_ITEMS = 'EXABORGANIZATIONLEAD_LIST_SET_TOTAL_ITEMS'
